import React from "react";
import {Box, Typography, Switch} from "@mui/material";
import {green, red} from "@mui/material/colors";

export default function AssessmentToggle({isAssessmentPassed, onChange}) {

    const assessmentPassedColor = green[700];
    const assessmentFailedColor = red[700];

    return (
      <Box display="flex" alignItems="center">
          <Typography fontWeight="bold" mr={1}>
              Pass
          </Typography>
          <Switch
            checked={isAssessmentPassed}
            onChange={onChange}
            sx={{
                "& .MuiSwitch-switchBase.Mui-checked": {
                    color: assessmentPassedColor,
                    "& + .MuiSwitch-track": {
                        backgroundColor: assessmentPassedColor,
                    },
                },
                "& .MuiSwitch-switchBase": {
                    color: assessmentFailedColor,
                    "& + .MuiSwitch-track": {
                        backgroundColor: assessmentFailedColor,
                    },
                },
            }}
          />
      </Box>
    );
}